import {getCookie} from "@/lib/utils"
import localforage from "@/services/localforage"
import {store} from "@/store"
import AuthAPI from "@/api/auth"

export default {
  initProfile() {
    store.dispatch("Auth/actionInitProfile")
  },
  isAuthenticated() {
    return !!getCookie("token")
  },
  forgetUser() {
    const date = new Date(0).toUTCString()
    localStorage.removeItem('userTokens')
    document.cookie = `token=; path=/; expires=${date}`
    store.dispatch("Auth/actionRemoveProfile")
    store.dispatch("Contexts/actionRemoveContexts")
  },
  getToken() {
    let token = getCookie("token")
    if (token) {
      return token
    } else {
      this.logout()
    }
  },
  getProfile() {
    return store.getters["Auth/getProfile"]
  },
  getModules() {
    let profile = this.getProfile()
    let modules = profile && profile.modules
    if (!modules) return modules
    modules = modules.map(item => item.toLowerCase())
    if (store.getters["App/getOrganizationTypeNew"] === 2) {
      modules = modules.filter(item => ["admin", "agrofact", "agroplan", "grainbalance", "agromap", "agrostock"].includes(item))
    }
    return modules
  },
  getRoles() {
    let profile = this.getProfile()
    return profile && profile.roleIds ? profile.roleIds : []
  },
  isDeveloper() {
    let profile = this.getProfile()
    return profile && profile.isDeveloper
  },
  isUser() {
    return !this.isDeveloper()
  },
  changePassword(id, passwords) {
    const token = this.getToken()
    let organizationId = store.getters["Contexts/getOrganization"]
    let module = store.getters["App/getModule"]
    let data = {
      "id": id,
      "currentPassword": passwords.old,
      "newPassword": passwords.new,
    }
    return new Promise((resolve, reject) => {
      if (!token)  {
        reject("LOGOUT")
      } else {
        let config = {headers: {"Content-Type": "application/json", "Authorization": token, organizationId, module}}
        AuthAPI.changePassword(data, config)
          .then(response => {
            resolve(response.data)
          })
          .catch((e) => {
            reject(e)
          })
      }
    })
  },
  saveProfile(data) {
    const token = this.getToken()
    let organizationId = store.getters["Contexts/getOrganization"]
    let module = store.getters["App/getModule"]
    return new Promise((resolve, reject) => {
      if (!token) {
        reject("LOGOUT")
      } else {
        let config = {headers: {"Content-Type": "application/json", "Authorization": token, organizationId, module}}
        AuthAPI.saveProfile(data, config)
          .then(response => {
            resolve(response.data)
          })
          .catch((e) => {
            reject(e)
          })
      }
    })
  },
  loadProfile() {
    const token = this.getToken()
    let organizationId = store.getters["Contexts/getOrganization"]
    let organizationsGroupId = store.getters["Contexts/getOrganizationsGroupId"]
    return new Promise((resolve, reject) => {
      if (!token) {
        reject("LOGOUT")
      } else {
        let config = {headers: {"Content-Type": "application/json", "Authorization": token}}
        if (organizationId) {config.headers.organizationId = organizationId}
        if (organizationsGroupId) {config.headers.organizationsGroupId = organizationsGroupId}
        AuthAPI.loadProfile(config)
          .then(response => {
            if (response.data) {
              store.dispatch("Auth/actionSetProfile", response.data)
            }
            response.data = response.data ? response.data : ""
            resolve(response.data)
          })
          .catch((e) => {
            reject(e)
          })
      }
    })
  },
  login(username = "", pass = "") {
    return new Promise((resolve, reject) => {
      let data = {
        "userName": username,
        "password": pass
      }
      let config = {
        headers: {
          "Content-Type": "application/json",
          "accept": "application/json"
        }
      }
      AuthAPI.login(data, config)
        .then(response => {
          store.dispatch("Auth/actionSetTokens", response.data)
          store.dispatch("Auth/actionSetStatus", "success")
          resolve()
        })
        .catch(error => {
          store.dispatch("Auth/actionSetStatus", "fail")
          if (error.response.data && error.response.data.error === "invalid_grant") {
            reject("INVALID")
          } else if (!error.response.data || error.response.status === 0 || error.response.status >= 500) {
            reject("NO_RESPONSE")
          } else {
            reject("OTHER")
          }
        })
    })
  },
  logout() {
    this.forgetUser()
    localforage.clear(() => {
      window.location = "/"
    })
  },
}
